import { useTranslation } from 'react-i18next'

import { useDate, useTimeZone } from '../../../hooks'
import Text from '../../Text'

import { getBirdviewRowDeadlineText } from './BirdviewRowDeadline.utils'

function BirdviewRowDeadline({ deadline, hint }) {
  const { t } = useTranslation()

  const now = useDate()
  const timeZone = useTimeZone()

  const text = getBirdviewRowDeadlineText({ deadline, hint, now, t, timeZone })

  return text ? <Text isSecondary>{text}</Text> : null
}

export default BirdviewRowDeadline
